
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericClosedBottom as ObiThreewayAcuatorGenericClosedBottomElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-closed-bottom.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericClosedBottom = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-closed-bottom',
   elementClass: ObiThreewayAcuatorGenericClosedBottomElement,
   events: {
     
   }
  });
 
 